// extracted by mini-css-extract-plugin
export const tag = "itemTags-module--tag--R1xGe";
export const tagsDivider = "itemTags-module--tagsDivider--naAo3";